// Project Imports
import Product from 'constants/ProductConstants';

const fetchChildFutureProtectBenefit = (solutionData) => {
    let childFutureList = []

    solutionData.coverage.forEach((coverage) => {
        coverage.life_assured_list.forEach(lifeAssured => {
            lifeAssured.product_details.forEach(obj => {
                let childfutureBenefit = fetchInputStringOpt('@PR_OPTION_6', obj.data.InputString) === "9"
                let benefitMessage = ""
                switch (obj.product_name) {
                    case Product.ZINDAGI_PROTECT:   
                    if (childfutureBenefit) {
                        let childSA = fetchInputStringOpt('@DISPLAY_PR_OPTION_8', obj.data.InputString)
                        let LA_ENTRY_AGE = fetchInputStringOpt('@LI_ENTRY_AGE', obj.data.InputString)
                        let CHILD_AGE = fetchInputStringOpt('@OPTION_VALUE_7', obj.data.InputString)
                            benefitMessage =`Enjoy ${childSA} extra Sum Assured till age ${(Number(LA_ENTRY_AGE) + (25 - Number(CHILD_AGE)))}`
                            if (!checkBenefitAvailable(benefitMessage, childFutureList))
                                childFutureList.push(benefitMessage)
                        }
                        break;
                }
            })
        })
    })

    return childFutureList
}

const fetchInputStringOpt = (key, inputString) => {
    return inputString.filter((item) => item.Key == key)[0]?.Value || 'NO'
}

const checkBenefitAvailable = (benefit, coverList) => {
    return coverList.some((item) => item === benefit)
}

export default fetchChildFutureProtectBenefit